seedWebApp.controller('MbfPricesController', ['$scope', '$uibModal', 'PricesService', 'TranslationService', function ($scope, $uibModal, PricesService, TranslationService) {
    $scope.translation = TranslationService.getActiveTranslation();

    //customClass: function () { return 'agp-color'; }
    console.log('MbfPrices');

    $scope.storageClass = function () {
        return 'sd-storage';
    };

    $scope.columns = [
        { name: 'MBFID', display: 'ID', filterOptions: [], width: 5, customClass: $scope.storageClass, isKey: true  },
        { name: 'MBFStartDate', display: 'Inicio Validade', dataType: 'date', format: 'dd/MM/yyyy', filterOptions: [], width: 5, isUTC: true },
        { name: 'MBFEndDate', display: 'Fim Validade', dataType: 'date', format: 'dd/MM/yyyy', filterOptions: [], width: 5, isUTC: true },
        { name: 'MBFValue', display: 'Preço Médio', currencyFormat: 'R$', dataType: 'number', filterOptions: [], width: 5 },
        { name: 'IsActive', display: 'Ativo', dataType: 'boolean', filterOptions: [], width: 5 },
    ];

    $scope.prefs = {
        name: 'MBFPricesGrid',
        selContact: null,
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false
    };

    $scope.loadService = PricesService.getMBFPrices;
    $scope.loadColumns = PricesService.getPricesColumns;    
    $scope.resetService = PricesService.resetCache;

    $scope.loadTotal = function () {
        $scope.loadingTotal = true;
        PricesService.getPricesCount().then(function (response) {
            $scope.loadingTotal = false;
            $scope.totalItems = response.data;
        });
    };

    $scope.loadTotal();

    $scope.searchMode = function () {
        $scope.$broadcast('inputSearch', $scope.filterString);
    };

    $scope.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    $scope.toExcel = function () {
        $scope.$broadcast('toExcel', 'Precos_Midea');
    };

    //$scope.prefs.customEdit = function (item) {
    //    var modalInstance = $uibModal.open({
    //        templateUrl: './SPA/Prices/pricesModal.html',
    //        controller: 'PricesModalCtrl',
    //        size: 'md',
    //        resolve: {
    //            materialID: function () {
    //                return item.MaterialID;
    //            }
    //        }
    //    });
    //    modalInstance.result.then(function () {
    //        $scope.doRefresh();
    //    });
    //};

}]);